// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallingPlaceholder__calling-placeholder-container-d4004d {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.CallingPlaceholder__group-title-e68b05 {
  color: var(--addition-50);
  font: var(--font-title-6);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 225px;
  margin-bottom: 4px;
}

.CallingPlaceholder__calling-state-c8232d {
  display: flex;
  align-items: center;
  color: var(--addition-50);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/Shared/CallingPlaceholder/CallingPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,wCAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAAF","sourcesContent":[".calling-placeholder-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.group-title {\n  color: var(--addition-50);\n  font: var(--font-title-6);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 225px;\n  margin-bottom: 4px;\n}\n\n.calling-state {\n  display: flex;\n  align-items: center;\n  color: var(--addition-50);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body);\n\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calling-placeholder-container": `CallingPlaceholder__calling-placeholder-container-d4004d`,
	"callingPlaceholderContainer": `CallingPlaceholder__calling-placeholder-container-d4004d`,
	"group-title": `CallingPlaceholder__group-title-e68b05`,
	"groupTitle": `CallingPlaceholder__group-title-e68b05`,
	"calling-state": `CallingPlaceholder__calling-state-c8232d`,
	"callingState": `CallingPlaceholder__calling-state-c8232d`
};
module.exports = ___CSS_LOADER_EXPORT___;
